import api from "./axios";

export const SessionSettings = async ({ queryKey }) => {
  const [device_id] = queryKey;
  const response = await api.get("/accounts/session/list/", {
    device_id,
  });
  return response.data.data;
};

export const AccountSettings = async () => {
  const response = await api.get("/common/settings/account-settings/");
  return response.data.data;
};

export const updateCredentials = async (payload) => {
  const response = await api.post("/common/email-phone-verify", payload);
  return response.data;
};

export const clearSession = async (payload) => {
  const response = await api.post("/accounts/session/clear/", payload);
  return response.data;
};

export const successStories = async (payload) => {
  const response = await api.patch("/blogs/success-story/create/", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateAuthentication = async (payload) => {
  const response = await api.post(
    "/accounts/settings/change-password/",
    payload,
  );
  return response.data;
};

export const updateNotifications = async (payload) => {
  const response = await api.patch(
    "/common/settings/save-notification-settings/",
    payload,
  );

  return response.data;
};

export const updatePersonalinfo = async (payload) => {
  const response = await api.patch(
    "/common/settings/save-personalised-settings/",
    payload,
  );

  return response.data;
};

export const sendOtp = async (payload) => {
  const response = await api.post("/common/send-verify-account-otp", payload, {
    headers: {
      "X-Platform": "1",
    },
  });

  return response.data;
};

export const verifyOtp = async (payload) => {
  const response = await api.post("/common/verify-account-otp", payload);

  return response.data;
};

export const deleteAccount = async (payload) => {
  const response = await api.post("/accounts/account/delete/", payload);

  return response.data;
};

export const privacyUpdate = async (payload) => {
  const response = await api.patch("/users/privacy-update/", payload);

  return response.data;
};
